import React from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Button } from 'react-bootstrap';
import { map } from 'lodash';
import uuid from 'uuid/v1';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

const LayerWMTSLayerField = ({
  layerSubType,
  wmtsLayerIds,
  wmtsLayerId,
  failedFetchDueToCORS,
  loadWMTSOptions
}) => {
  if (LAYER_SUBTYPES.WMTS === layerSubType) {
    const wmtsLayers = wmtsLayerIds.split(',');
    return (
      <Form.Group>
        <Form.Label>Layer</Form.Label>
        {!failedFetchDueToCORS && (
          <Form.Row>
            <Col>
              <Form.Control
                as="select"
                name="wmtsLayer"
                value={wmtsLayerId}
                placeholder="What's the code name for the layers?"
                onChange={loadWMTSOptions}
              >
                <option>Select one Layer</option>
                {map(wmtsLayers, wmtsLayer => (
                  <option key={uuid()} value={wmtsLayer}>
                    {wmtsLayer}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Button onClick={loadWMTSOptions}>Reload</Button>
          </Form.Row>
        )}
        {failedFetchDueToCORS && (
          <>
            <Form.Control
              type="text"
              name="layerNamesInputWMTS"
              defaultValue=""
              placeholder="What's the code name for the layers?"
            />
            <Form.Text className="text-muted text-break">
              Enter the layer ids separated by commas, no spaces. Example:
              <br />
              TN.RailTransportNetwork.RailwayLink,TN.RoadTransportNetwork.RoadLink,TN.AirTransportNetwork.RunwayArea
            </Form.Text>
          </>
        )}
      </Form.Group>
    );
  }
  return '';
};

LayerWMTSLayerField.propTypes = {
  loadWMTSOptions: PropTypes.func.isRequired,
  layerSubType: PropTypes.string.isRequired,
  wmtsLayerId: PropTypes.string.isRequired,
  wmtsLayerIds: PropTypes.string.isRequired,
  failedFetchDueToCORS: PropTypes.bool.isRequired,
  urlIncludesWMTSOptions: PropTypes.bool.isRequired
};

export default LayerWMTSLayerField;
